import { css, sva } from "@stubhub/broadway-foundation/css";

export const guaranteeHighlightsContainer = css({
  display: "flex",
  flexDirection: "column",
  columnGap: "primitives.150",
  rowGap: "primitives.150",
});

export const guaranteeHighlightItemRecipe = sva({
  slots: ["row", "iconContainer", "textContainer", "titleText", "descriptionText"],
  className: "guaranteeHighlightItem",
  base: {
    row: {
      display: "flex",
      flexDirection: "row",
      columnGap: "primitives.200",
      alignSelf: "stretch",
    },
    iconContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "bg.surface.strong",
      borderStartStartRadius: "primitives.150",
      borderStartEndRadius: "primitives.150",
      borderEndEndRadius: "primitives.150",
      borderEndStartRadius: "primitives.150",
      width: "[40px]",
      height: "[40px]",
    },
    textContainer: {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      flexShrink: 0,
      flexBasis: "primitives.0",
    },
    titleText: {
      fontSize: "primitives.350",
      fontWeight: "bold",
    },
    descriptionText: {
      fontSize: "primitives.350",
      fontWeight: "regular",
      color: "text.subtle",
    },
  },
  variants: {
    descriptionVisibility: {
      shown: {
        textContainer: {
          alignItems: "flex-start",
        },
      },
      hidden: {
        textContainer: {
          justifyContent: "center",
        },
      },
    },
  },
  defaultVariants: {
    descriptionVisibility: "shown",
  },
});

export const linkStyleClass = css({
  "& a": {
    color: "text.link",
    _hover: {
      color: "text.link.hover",
    },
    _active: {
      color: "text.link.active",
    },
    _visited: {
      color: "text.link.visited",
    },
  },
});
